import {ActionTypes} from '../actions';
import createReducer, {getActionsObject} from '../../common/util/createReducer';

const INITIAL_STATE = {
  'loading': false,
  'filterText': '',
  'list': [],
  'filteredList': [],
};

export const origin = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.LOAD_ORIGINS_REQUEST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.LOAD_ORIGINS_SUCCESS]: (state, action) => ({
      ...state,
      'list': action.response.data,
      'filteredList': action.response.data,
      'loading': false,
    }),
    [ActionTypes.LOAD_ORIGINS_FAILED]: (state, action) => ({
      ...state,
      'list': [],
      'filteredList': [],
      'loading': false,
    }),
    [ActionTypes.CHANGE_ORIGIN_TEXT_FILTER]: (state, action) => ({
      ...state,
      'filterText': action.payload,
    }),
    [ActionTypes.FILTER_ORIGINS]: (state, action) => ({
      ...state,
      'filteredList': state.list.filter((element) =>
        [
          element.code || '',
          element.origin || '',
        ].some((text) =>
          text.toLowerCase().includes(action.payload.toLowerCase()) || action.payload === ''
        )
      ),
    }),
  })(state, action);
};

export const originForm = (state, action) => {
  return createReducer({}, {
    [ActionTypes.INITIALIZE_ORIGIN_DATA]: (state, action) => ({
      ...state,
      'values': {
        ...state.values,
        'origin': action.payload.origin,
        'status': action.payload.status,
      },
    }),
    ...getActionsObject('SUBMIT_NEW_ORIGIN', {
      ActionTypes,
      'failed': 'Ocurrió un error al crear un nuevo origen',
      'success': 'Origen creado satisfactoriamente',
    }),
    ...getActionsObject('SUBMIT_EDIT_ORIGIN', {
      ActionTypes,
      'failed': 'Ocurrió un error al editar el origen seleccionado',
      'success': 'Origen actualizado satisfactoriamente',
    }),
  })(state, action);
};
